import React, { useContext } from 'react';
import HomeContainer from './container';
import { basePath } from '../flow/flow';
import { enrollmentContext } from '../../hoc/context/enrollment/enrollment-context';
import HomeContent from './content';
import { navigate } from 'gatsby';

const Home: React.FC<{}> = () => {
	const enrollmentCtxt = useContext(enrollmentContext);
	enrollmentCtxt.resetInput();

	const next = () => {
		navigate(basePath);
	};

	return (
		<HomeContainer>
			<HomeContent next={next} nextPath={basePath} />
		</HomeContainer>
	);
};

export default Home;
